<ng-content></ng-content>
<i class="now-ui-icons sort-dirction" [ngClass]="{ 'arrows-1_minimal-up': sortDirection === 'asc', 'arrows-1_minimal-down' : sortDirection === 'desc' }"></i>